import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/CustomButtonEdit.css';

/**
 * Кастомная кнопка удаления с иконкой.
 * Обычно используется для удаления элементов в списке, таблице или карточке.
 *
 * @component
 * @param {Object} props - Свойства компонента.
 * @param {function} props.onClick - Обработчик клика по кнопке.
 * @param {string} [props.margin] - Значение отступа вокруг кнопки.
 * @param {boolean} [props.disabled] - Флаг, отключающий кнопку.
 *
 * @returns {JSX.Element} Кнопка с иконкой удаления.
 */
function CustomButtonDelete({ onClick, margin, disabled }) {
  const buttonStyle = {
    margin: margin,
  };
  return (
    <button className="custom-button-edit" style={buttonStyle} onClick={onClick} disabled={disabled}>
      <img className="" src="/image/delete.svg" alt="Иконка" />
    </button>
  );
}

CustomButtonDelete.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CustomButtonDelete;
